export const HomepageMarquee = () => {
  const items = [
    "✦ 500+ Creators",
    "✦ 60-Day Guarantee",
    "✦ AI-Powered",
    "✦ Free Trial",
    "✦ 8 AI Tools",
    "✦ No Experience Needed",
    "✦ Cancel Anytime",
  ];

  return (
    <div className="overflow-hidden py-4" style={{ backgroundColor: "#F3F4F6", borderTop: "1px solid #E5E7EB", borderBottom: "1px solid #E5E7EB" }}>
      <div className="quiz-marquee-track">
        {[...items, ...items].map((item, i) => (
          <span key={i} className="inline-flex items-center px-5 text-sm font-medium whitespace-nowrap" style={{ color: "#6B7280" }}>
            {item}
          </span>
        ))}
      </div>
    </div>
  );
};
